import React, { useEffect, useState } from 'react';
interface TypewriterProps {
  text: string;
  /** Milliseconds per character. */
  speed?: number;
  /** Delay before typing starts, so the hero can settle first. */
  delay?: number;
  className?: string;
}

/**
 * Types the greeting out once on arrival, like a line coming over the wire.
 * Respects reduced-motion by rendering the finished string immediately.
 */
export function Typewriter({
  text,
  speed = 62,
  delay = 180,
  className = ''
}: TypewriterProps) {
  const [shown, setShown] = useState(0);
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setShown(text.length);
      setDone(true);
      return;
    }
    setShown(0);
    setDone(false);
    let index = 0;
    let interval = 0;
    const start = window.setTimeout(() => {
      interval = window.setInterval(() => {
        index += 1;
        setShown(index);
        if (index >= text.length) {
          window.clearInterval(interval);
          setDone(true);
        }
      }, speed);
    }, delay);
    return () => {
      window.clearTimeout(start);
      window.clearInterval(interval);
    };
  }, [delay, speed, text]);
  return <span className={className} data-id="element-256" data-mp="1c2hpmudsqptp">
      {/* Screen readers get the whole line, not a half-typed one. */}
      <span className="sr-only" data-id="element-257" data-mp="179oijzuuv5eg">{text}</span>
      <span aria-hidden="true" data-id="element-258" data-mp="178wowuktjhqt">
        {text.slice(0, shown)}
        <span className={`ml-0.5 inline-block h-[0.78em] w-[0.06em] translate-y-[0.04em] bg-gold align-baseline ${done ? 'animate-pulse' : ''}`} data-id="element-259" data-mp="1lycalw5hswzn" />
      </span>
    </span>;
}